import { render, staticRenderFns } from "./B2BRegistrationComponent.vue?vue&type=template&id=4b590244&scoped=true&"
import script from "./B2BRegistrationComponent.vue?vue&type=script&lang=ts&"
export * from "./B2BRegistrationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./B2BRegistrationComponent.vue?vue&type=style&index=0&id=4b590244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b590244",
  null
  
)

export default component.exports